<template>
    <v-checkbox
        v-bind="$attrs"
        :input-value="Boolean(value)"
        :color="color"
        class="main--text"
        :disabled="disabled"
        :label="label"
        :hide-details="!errorMessages"
        @change="$emit('change', $event)"
    >
        <template v-slot:label>
            <slot>
                <div class="body-2 main--text">{{ label }}</div>
            </slot>
        </template>
    </v-checkbox>
</template>

<script>
export default {
    name: "Checkbox",
    props: {
        value: {
            type: [Boolean, Number],
            default: false
        },
        label: {
            type: String,
            default: ""
        },
        errorMessages: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'primary'
        }
    }
}
</script>
